import { useQuery } from 'react-query';
import { getV1Data } from '../api/getV1Data';
import { prettyDate } from '../helpers/helpers';
import { getFoodGroupChangeValue } from '../helpers/navigation';
import _ from 'lodash';

const useV1Data = (props) => {
  const result = useQuery('v1_data', () => getV1Data(props), {
    refetchOnWindowFocus: false,
    staleTime: 50000,
  });
  return { ...result, ...prepareData(result.data) };
};

const prepareData = (data) => {
  if (data) {
    const dietsById = _.keyBy(data.diets, 'id');
    const usersById = _.keyBy(data.users, 'id');
    const workflowsByUserId = _.groupBy(data.workflows, 'userId');
    const subscriptionsByUserId = _.groupBy(data.challengeSubscriptions, 'userId');

    // console.log('Debug here')
    // console.log(dietsById)
    // console.log(usersById)
    // console.log(workflowsByUserId)
    // console.log(subscriptionsByUserId)

    data.diets.forEach((diet) => {
      // @todo: drop food_group_values once it's no longer relied on by core
      diet.food_group_values = diet.foodGroupValues;
    });
    data.diets.forEach((diet) => {
      // @todo: drop food_group_values once it's no longer relied on by core
      diet.food_group_values = diet.foodGroupValues;
    });

    data.users.forEach((user) => {
      user.challengeSubscriptions = subscriptionsByUserId[user.id] || [];
      user.workflows = workflowsByUserId[user.id] || [];
      // alert(JSON.stringify(workflowsByUserId))
    });

    data.workflows = data.workflows.map((workflow) => {
      const idDiet = dietsById[workflow.idDietId] ? dietsById[workflow.idDietId] : null;
      const idealDiet = dietsById[workflow.idealDietId] ? dietsById[workflow.idealDietId] : null;

      workflow.user = usersById[workflow.userId];
      workflow.idDiet = idDiet;
      workflow.idealDiet = idealDiet;
      workflow.foodGroupChanges = getFoodGroupChangeValue(idDiet, idealDiet);
      workflow.createdAt = prettyDate(workflow.createdAt);
      workflow.updatedAt = prettyDate(workflow.updatedAt);

      delete workflow.userId;
      delete workflow.idDietId;
      delete workflow.idealDietId;

      return workflow;
    });
  }

  return data;
};

export default useV1Data;
